"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function newTxVisitor(ctx, id) {
    let allowPending = false;
    return {
        get id() {
            return id;
        },
        allowPending() {
            allowPending = true;
            return this;
        },
        get: () => ctx.driver.getTransaction(id, allowPending),
        getReceipt: () => ctx.driver.getReceipt(id)
    };
}
exports.newTxVisitor = newTxVisitor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHgtdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90eC12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsU0FBZ0IsWUFBWSxDQUN4QixHQUFZLEVBQ1osRUFBVTtJQUVWLElBQUksWUFBWSxHQUFHLEtBQUssQ0FBQTtJQUN4QixPQUFPO1FBQ0gsSUFBSSxFQUFFO1lBQ0YsT0FBTyxFQUFFLENBQUE7UUFDYixDQUFDO1FBQ0QsWUFBWTtZQUNSLFlBQVksR0FBRyxJQUFJLENBQUE7WUFDbkIsT0FBTyxJQUFJLENBQUE7UUFDZixDQUFDO1FBQ0QsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsY0FBYyxDQUFDLEVBQUUsRUFBRSxZQUFZLENBQUM7UUFDdEQsVUFBVSxFQUFFLEdBQUcsRUFBRSxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsVUFBVSxDQUFDLEVBQUUsQ0FBQztLQUM5QyxDQUFBO0FBQ0wsQ0FBQztBQWhCRCxvQ0FnQkMifQ==